export default function TS_Type_Inference() {
  return (
    <div>
      <h1>TS Type Inference</h1>
      <p>This is the TS Type Inference page.</p>
    </div>
  );
}